module.exports = __webpack_public_path__ + "img/i_location_g.89203498.svg";